var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPossible1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 70,
    viewBox: "0 0 46 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 164141"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 163553",
    transform: "translate(-308.026 -1388.027)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "\\uC0AC\\uAC01\\uD615 148355",
    width: 35.526,
    height: 35.526,
    rx: 4,
    transform: "translate(315.131 1407.131)",
    style: {
      fill: "#ffd133"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "\\uC0AC\\uAC01\\uD615 148354",
    width: 34.342,
    height: 34.342,
    rx: 3,
    transform: "translate(313.947 1405.947)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 148349",
    transform: "translate(326.973 1418.973)",
    style: {
      fill: "#ffd133"
    },
    d: "M0 0h8.289v8.289H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.493 37.58V27.493H37.58V37.58zm1.761-1.761h6.565v-6.565h-6.565zm-4.243 19.454V50.79h-6.4a4.374 4.374 0 0 1-4.323-4.323v-6.4H9.8V38.3h4.483V26.692H9.8v-1.761h4.483v-6.4a4.374 4.374 0 0 1 4.323-4.331h6.4V9.8h1.761v4.4h11.614V9.8h1.761v4.4h6.4a4.374 4.374 0 0 1 4.323 4.323v6.4h4.4v1.761h-4.4V38.3h4.4v1.761h-4.4v6.4a4.374 4.374 0 0 1-4.323 4.323h-6.4v4.483h-1.761V50.79H26.772v4.483zm21.536-6.245a2.755 2.755 0 0 0 2.562-2.562v-27.94a2.755 2.755 0 0 0-2.562-2.562H18.606a2.755 2.755 0 0 0-2.562 2.562v27.94a2.755 2.755 0 0 0 2.562 2.562zm-14.01-16.491z",
    transform: "translate(298.226 1390.228)",
    style: {
      fill: "#191919"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPossible1);
export default __webpack_public_path__ + "static/media/possible-1.a3f260eb08510d80949370fe1f243600.svg";
export { ForwardRef as ReactComponent };